import { useTranslation } from 'react-i18next'
import { Dispatch, SetStateAction } from 'react'
import TransparentDrawerLayout from './layouts/TransparentDrawerLayout/TransparentDrawerLayout'
import ExtraTip from './layouts/ExtraTip/ExtraTip'
import styles from './TransparentDrawer.module.scss'

interface TransparentDrawerProps {
  setIsTransparentDrawerOpen: Dispatch<SetStateAction<boolean>>
  isTransparentDrawerOpen: boolean
}

function TransparentDrawer({
  setIsTransparentDrawerOpen,
  isTransparentDrawerOpen
}: TransparentDrawerProps) {
  const { t } = useTranslation()

  const closeDrawer = () => {
    setIsTransparentDrawerOpen(false)
  }

  return (
    <div
      className={`${styles.drawerWrapper} ${
        isTransparentDrawerOpen ? styles.drawerWrapperOpen : ''
      }`}
    >
      <TransparentDrawerLayout
        closeDrawer={closeDrawer}
        title={t('MOBILE_APP.TRANSPARENT_DRAWER.TITLE')}
      >
        <ExtraTip />
      </TransparentDrawerLayout>
    </div>
  )
}

export default TransparentDrawer
